import { useState } from 'react'
import { Safety } from '../classes/Safety'
import { Location } from '../types/models'

/**
 * A pass through hook to store and retrieve location information from the local storage.
 */
export const useLocations = (): [locations: Location[], setLocations: (locations: Location[]) => void] => {
  const [locations, _setLocations] = useState<Location[]>(Safety.get('locations', []))

  const setLocation = (locations: Location[]): void => {
    Safety.set('locations', locations.length ? locations : undefined)
    _setLocations(locations)
  }

  return [locations, setLocation]
}
